/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Docs_LinkInputs */

const en_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Full parameter and response reference - every field, type, and example for this endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Full parameter and response reference" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " - every field, type, and example for this endpoint." }])
			})
		}
	)
);

const zh_hans1_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`完整的参数与响应参考：这个接口的每个字段、类型和示例。`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "完整的参数与响应参考" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "：这个接口的每个字段、类型和示例。" }])
			})
		}
	)
);

const pt_br2_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Referência completa de parâmetros e resposta - todos os campos, tipos e exemplos deste endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Referência completa de parâmetros e resposta" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " - todos os campos, tipos e exemplos deste endpoint." }])
			})
		}
	)
);

const es_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Referencia completa de parámetros y respuesta: cada campo, tipo y ejemplo de este endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Referencia completa de parámetros y respuesta" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ": cada campo, tipo y ejemplo de este endpoint." }])
			})
		}
	)
);

const fr_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Référence complète des paramètres et de la réponse : chaque champ, type et exemple de cet endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Référence complète des paramètres et de la réponse" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " : chaque champ, type et exemple de cet endpoint." }])
			})
		}
	)
);

const de_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Vollständige Parameter- und Antwortreferenz: jedes Feld, jeder Typ und jedes Beispiel für diesen Endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Vollständige Parameter- und Antwortreferenz" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ": jedes Feld, jeder Typ und jedes Beispiel für diesen Endpoint." }])
			})
		}
	)
);

const ru_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Полный справочник по параметрам и ответу: каждое поле, тип и пример для этого эндпоинта.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Полный справочник по параметрам и ответу" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: ": каждое поле, тип и пример для этого эндпоинта." }])
			})
		}
	)
);

const it_endpoint_docs_link = /** @type {((inputs: Endpoint_Docs_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Docs_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Riferimento completo di parametri e risposta - ogni campo, tipo ed esempio per questo endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Docs_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Riferimento completo di parametri e risposta" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: " - ogni campo, tipo ed esempio per questo endpoint." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Full parameter and response reference - every field, type, and example for this endpoint." |
*
* @param {Endpoint_Docs_LinkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_docs_link = /** @type {((inputs?: Endpoint_Docs_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Endpoint_Docs_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Docs_LinkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Endpoint_Docs_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_docs_link(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_docs_link(inputs)
			if (locale === "es") return es_endpoint_docs_link(inputs)
			if (locale === "fr") return fr_endpoint_docs_link(inputs)
			if (locale === "de") return de_endpoint_docs_link(inputs)
			if (locale === "ru") return ru_endpoint_docs_link(inputs)
			if (locale === "it") return it_endpoint_docs_link(inputs)
			return en_endpoint_docs_link(inputs)
		}),
		{
			parts: /** @type {(inputs?: Endpoint_Docs_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_docs_link.parts === "function" ? zh_hans1_endpoint_docs_link.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_docs_link(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_docs_link.parts === "function" ? pt_br2_endpoint_docs_link.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_docs_link(inputs) }]
				if (locale === "es") return typeof es_endpoint_docs_link.parts === "function" ? es_endpoint_docs_link.parts(inputs) : [{ type: "text", value: es_endpoint_docs_link(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_docs_link.parts === "function" ? fr_endpoint_docs_link.parts(inputs) : [{ type: "text", value: fr_endpoint_docs_link(inputs) }]
				if (locale === "de") return typeof de_endpoint_docs_link.parts === "function" ? de_endpoint_docs_link.parts(inputs) : [{ type: "text", value: de_endpoint_docs_link(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_docs_link.parts === "function" ? ru_endpoint_docs_link.parts(inputs) : [{ type: "text", value: ru_endpoint_docs_link(inputs) }]
				if (locale === "it") return typeof it_endpoint_docs_link.parts === "function" ? it_endpoint_docs_link.parts(inputs) : [{ type: "text", value: it_endpoint_docs_link(inputs) }]
				return typeof en_endpoint_docs_link.parts === "function" ? en_endpoint_docs_link.parts(inputs) : [{ type: "text", value: en_endpoint_docs_link(inputs) }]
			})
		}
	)
);